<template>
  <div class="container">
    <div class="top_title">
      <router-link class="icon_back" :to="{path:'/H400061/' + backId}" tag="span"></router-link>
      <p>{{info.I_TITLE_NAME}}</p>
    </div>
    <div class="weui-flex top_tabs">
      <div class="weui-flex__item"><span :class="{active: tab == 1}" @click="clickTab(1)">观看最多</span></div>
      <div class="weui-flex__item"><span  :class="{active: tab == 2}" @click="clickTab(2)">最新上架</span></div>
      <div class="weui-flex__item"><span  :class="{active: tab == 3}" @click="clickTab(3)">最近记录</span></div>
    </div>
    <div class="scroll_area" style="overflow-y: scroll">
      <div v-if="tempList.length > 0" class="weui-grids" style="overflow-y: auto">
        <div v-for="item,index in tempList"
                     class="weui-grid" @click="goToDetail(item)" :key="item.id">
          <!--<img :src="item.I_ICON_QNY" />-->
          <div class="img" :style="{ 'background-image': 'url(' + item.I_ICON_QNY + ''}" />
          <p class="title" style="-webkit-box-orient: vertical;">{{item.I_TITLE}}</p>

          <img class="icon_play" src="../assets/images/icon_play3.jpg" alt="">
        </div>
    </div>
      <p v-if="tempList.length > 0" style="height: 30px;line-height: 30px;text-align: center;color: #aaa;font-size: 0.9rem;">{{loadState}}</p>

      <template v-if="tempList.length == 0 && message!=''">
        <NoRecord :Message = "message"></NoRecord>
      </template>
    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>

  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'
  import NoRecord from '../components/NoRecord.vue'

  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: true,
          jchd: false,
          yyst: false,
          wd: false,
        },
        dataList: [],
        tempList: [
        ],
        info: {},
        listLength: 0,
        count: 2,
        loadState: "加载中......",
        message: "",
        tab: 1,
        I_KEY: "",
        backId: ""
      }
    },
    components: {
      Footer,
      NoRecord
    },
    created() {
      this.backId = window.localStorage.getItem("H400061")
      this.I_KEY = this.$route.params.id?this.$route.params.id:window.localStorage.getItem("H400062")
      if(this.I_KEY) {
        window.localStorage.setItem("H400062", this.I_KEY)
      }
      this.init(1)

    },
    methods: {
      goToDetail(item) {
        this.$router.push({name: item.I_HTML_URL})
        window.localStorage.setItem("H400063",item.I_VIDEO_NO_SYS)
      },
      init(type) {
        let vm = this
        let param = {
          I_KEY: this.I_KEY,
          I_Flag: type
        }
        DataRequestFactory.I4000621(param).then((response) => {
          this.info = response
          if(response.dataList.length == 0) {
            this.message = '无查询记录！'
          } else {
            this.message = ''
          }
          if(response.dataList.length <= 12) {
            this.loadState = "加载完成"
          } else {
            this.loadState = "加载中......"
          }
          this.dataList = response.dataList
          this.listLength = response.dataList.length
          this.tempList = this.dataList.splice(0,12)

          setTimeout(function() {
            $(".scroll_area").scrollTop(0)
            vm.count = 2
          },500)
        })
      },
      clickTab(value) {
        this.tab = value
        this.init(value)
      },
      //获取滚动条当前的位置
      getScrollTop() {
        var scrollTop = 0;
        if(document.documentElement && document.documentElement.scrollTop) {
          scrollTop = document.documentElement.scrollTop;
        } else if(document.body) {
          scrollTop = document.body.scrollTop;
        }
        return scrollTop;
      },
      //获取当前可视范围的高度
      getClientHeight() {
        var clientHeight = 0;
        if(document.body.clientHeight && document.documentElement.clientHeight) {
          clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
        } else {
          clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
        }
        return clientHeight;
      },
      //获取文档完整的高度
      getScrollHeight() {
        return Math.max(document.body.scrollHeight, $('.container')[0].scrollHeight);
      }
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 8.2
      $(".scroll_area").css("height", heightDiff + "px"   )

      let vm = this
      $(".scroll_area").scroll(function(){
        if($(this)[0].scrollTop + $(this)[0].clientHeight + 80 > $(this)[0].scrollHeight) {
          if(vm.count <= Math.ceil(vm.listLength/3)) {
            if(vm.count + 1 >= Math.ceil(vm.listLength/3)) {
              vm.loadState = "加载完成"
            }
            var list = vm.dataList.splice(0, 3)
            vm.tempList = vm.tempList.concat(list);

            vm.count++;
          }
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H400062.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H400062.vue